<template>
    <textarea rows="8" :class="{ 'dark:bg-gray-900 dark:text-white dark:border-gray-800': !ignoreDarkMode }" class="text-gray-800 border-gray-300 focus:border-indigo-300 focus:ring focus:ring-indigo-200 focus:ring-opacity-50 rounded-md shadow-sm transition duration-500 ease-in-out" :value="modelValue" @input="$emit('update:modelValue', $event.target.value)" ref="textarea"></textarea>
</template>
<script>
export default {
    props: {
        ignoreDarkMode: Boolean,
        modelValue: String
    },

    emits: ['update:modelValue'],

    methods: {
        focus() {
            this.$refs.textarea.focus()
        }
    }
}

</script>
